import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { type Enum } from '@webapp/infrastructure/types/Enum'
import messages from './messages'

export const SettingsExpenseFormPageTabs = {
  GENERAL: 'general',
  MILEAGE: 'mileage',
} as const

export type SettingsExpenseFormPageTab = Enum<
  typeof SettingsExpenseFormPageTabs
>

export interface SettingsExpenseFormPageParams {
  tab?: SettingsExpenseFormPageTab
}

const SettingsExpenseFormViewChunk = lazy(() =>
  import('@webapp/modules/expense/feature-sets/SettingsExpenseFormView').then(
    ({ SettingsExpenseFormView }) => ({
      default: SettingsExpenseFormView,
    })
  )
)

export const SettingsExpenseFormPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.settingsBreadcrumb),
          link: url('SettingsPage'),
        },
        { name: intl.formatMessage(messages.pageTitle) },
      ]}
    >
      <SettingsExpenseFormViewChunk />
    </Page>
  )
}
